import * as p from '@clack/prompts'
import type { BetterstartCommandRuntime, Cancellable } from '@cli-types/core-engine/commands.js'
import type { Command } from 'commander'
import { CANCELLED } from '@cli-constants/commands.js'
import { cancelled } from './cancelled.js'
import { promptRequiredArguments } from './prompt-required-arguments.js'

export async function promptInvocation(
  program: Command,
  runtime: BetterstartCommandRuntime,
  cwd: string
): Promise<Cancellable<string[]>> {
  const name = await p.select({
    message: 'What do you want to do?',
    options: program.commands.map((command) => ({
      value: command.name(),
      label: command.name(),
      hint: command.description()
    }))
  })
  if (p.isCancel(name)) {
    return CANCELLED
  }

  const args = await promptRequiredArguments(name, runtime, cwd)
  if (cancelled(args)) {
    return CANCELLED
  }

  return [name, ...args]
}
